import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { WhyCoPro } from './components/WhyCoPro';
import { Industries } from './components/Industries';
import { ServiceArea } from './components/ServiceArea';
import { CtaBanner } from './components/CtaBanner';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { useSeo } from './hooks/useSeo';
import { company } from './data/site';
const TITLE = 'CoPro Services | Commercial Painting & Industrial Services Orlando';
const DESCRIPTION = 'Professional commercial painting, industrial cleaning and property services in Orlando and Central Florida. Personalized service and reliable solutions from CoPro Services.';
const STRUCTURED_DATA = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: company.name,
  description: DESCRIPTION,
  image: company.logoUrl,
  logo: company.logoUrl,
  telephone: '+1-407-436-7930',
  email: company.email,
  slogan: company.tagline,
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Orlando',
    addressRegion: 'FL',
    addressCountry: 'US'
  },
  areaServed: [{
    '@type': 'City',
    name: 'Orlando'
  }, {
    '@type': 'AdministrativeArea',
    name: 'Central Florida'
  }],
  makesOffer: ['Commercial painting Orlando', 'Industrial painting Orlando', 'Commercial cleaning Orlando', 'Industrial cleaning Orlando', 'Commercial property services Orlando'].map(name => ({
    '@type': 'Offer',
    itemOffered: {
      '@type': 'Service',
      name
    }
  }))
};
export function App() {
  useSeo({
    title: TITLE,
    description: DESCRIPTION,
    structuredData: STRUCTURED_DATA
  });
  return <div className="min-h-full w-full bg-white font-sans text-charcoal-800" data-id="element-0" data-mp="nuhg0bzipzr4">
      <Header data-id="element-1" data-mp="sudoanf90dch" />
      <main data-id="element-2" data-mp="studdqo0mp7y">
        <Hero data-id="element-3" data-mp="stc9c7v436ph" />
        <About data-id="element-4" data-mp="st2kinlsz5ld" />
        <Services data-id="element-5" data-mp="swqbpg3rzfwx" />
        <WhyCoPro data-id="element-6" data-mp="36hvn4muyo06" />
        <Industries data-id="element-7" data-mp="35yn2ej3lbyt" />
        <ServiceArea data-id="element-8" data-mp="356ttacz3qbp" />
        <CtaBanner data-id="element-9" data-mp="34nc9ur8j3y7" />
        <Contact data-id="element-10" data-mp="38b6kw4i7udz" />
      </main>
      <Footer data-id="element-11" data-mp="3udazyhcy738x" />
    </div>;
}